import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

const UserProfileDropdown = ({ user, onSignOut }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const menuItems = [
    { label: 'Profile & Progress', path: '/profile-progress', icon: 'User' },
    { label: 'Social & Rankings', path: '/social', icon: 'Award' },
    { label: 'Interview History', path: '/interview-report', icon: 'History' },
    /*
    Pilot disabled: settings and support pages are retained for post-pilot restore.
    { label: 'Settings', path: '/settings', icon: 'Settings' },
    { label: 'Help & Support', path: '/help', icon: 'HelpCircle' }
    */
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef?.current && !dropdownRef?.current?.contains(event?.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleSignOut = () => {
    setIsOpen(false);
    if (onSignOut) onSignOut();
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-muted transition-smooth"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        <div className="w-8 h-8 rounded-full overflow-hidden flex items-center justify-center bg-gradient-primary">
          {user?.profile_picture_url ? (
            <img
              src={user.profile_picture_url}
              alt={user.full_name || 'User'}
              className="w-full h-full object-cover"
              referrerPolicy="no-referrer"
            />
          ) : (
            <Icon name="User" size={16} color="#FFFFFF" />
          )}
        </div>
        <span className="text-sm font-medium text-foreground hidden lg:block">
          {user?.full_name || 'Student'}
        </span>
        <Icon name="ChevronDown" size={16} className={`transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      {isOpen && (
        <div className="absolute right-0 top-full mt-2 w-64 bg-popover border border-border rounded-lg shadow-elevation-3 z-[150] animate-scale-in">
          <div className="p-4 border-b border-border">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full overflow-hidden flex items-center justify-center bg-gradient-primary">
                {user?.profile_picture_url ? (
                  <img
                    src={user.profile_picture_url}
                    alt={user.full_name || 'User'}
                    className="w-full h-full object-cover"
                    referrerPolicy="no-referrer"
                  />
                ) : (
                  <Icon name="User" size={20} color="#FFFFFF" />
                )}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-foreground truncate">
                  {user?.full_name || 'Student'}
                </p>
                <p className="text-xs text-muted-foreground truncate">
                  {user?.email || 'student@example.com'}
                </p>
              </div>
            </div>
          </div>

          <nav className="p-2">
            {menuItems?.map((item) => (
              <Link
                key={item?.path}
                to={item?.path}
                className="flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted transition-smooth"
                onClick={() => setIsOpen(false)}
              >
                <Icon name={item?.icon} size={18} />
                <span>{item?.label}</span>
              </Link>
            ))}
          </nav>

          <div className="p-2 border-t border-border">
            <button
              className="flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium text-destructive hover:bg-destructive/10 transition-smooth w-full"
              onClick={handleSignOut}
            >
              <Icon name="LogOut" size={18} />
              <span>Sign Out</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserProfileDropdown;
